exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SliderSliders .items .Item{position:relative}.SliderSliders .items .Item .count-slider{position:absolute;background:#00adff;color:#fff;padding:5px;z-index:9}.SliderSliders .items .Item .checkbox-item{position:absolute;z-index:9;right:5px;top:2px}.SliderSliders .items .Item .ItemImage{width:100%;height:100%;background-position:50%;background-size:contain;background-repeat:no-repeat}.SliderSliders .items .Item .ItemQuestion{padding:10px;display:flex;justify-content:center}.SliderSliders .items .Item .ItemQuestion img{max-width:100%;max-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Slider/components/Sliders/components/Item/style.scss
// module id = 5281
// module chunks = 0